import React from 'react';

import AddUserForm from './AddUserForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRestrictedActionShowState, useRestrictedActionShowActions } from './RestrictedActionShowContext';

import styles from './RestrictedActionModal.module.scss';

const AddUserModal = ({ restrictedAction }) => {
  const state = useRestrictedActionShowState();
  const { closeAddUserModal } = useRestrictedActionShowActions();

  return (
    <StandardModal
      isOpen={state?.addUserModalIsOpen}
      onRequestClose={() => {
        closeAddUserModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Add User to Restricted Action
        </h2>
        <AddUserForm restrictedAction={restrictedAction} />
      </section>
    </StandardModal>
  );
};

export default AddUserModal;
